export const BREAKPOINTS = {
  SMALL: '30em',
  MEDIUM: '48em',
  LARGE: '78em',
  XLARGE: '120em',
};
